import { createStore, get, set, setMany, del, delMany, clear, keys, values } from 'idb-keyval';

const store = createStore('aerocle', 'saved-companies')

export const MAX_SAVED_COMPANIES = 250

function toSavedCompany(company) {
  return {
    id: company.id,
    company_name: company.company_name,
    campaign: company.campaign,
    previous_campaigns: company.previous_campaigns,
    website_url: company.website_url,
    address: company.address,
    city: company.city,
    state: company.state,
    zip: company.zip,
    country: company.country,
    description: company.description,
    account_manager_research_notes: company.account_manager_research_notes,
    client_feedback: company.client_feedback,
    current_client_feedback: company.current_client_feedback,
    client_feedback_notes: company.client_feedback_notes,
    current_client_feedback_notes: company.current_client_feedback_notes,
    ai_summary: company.ai_summary,
    crm_statuses: company.crm_statuses,
    crm_next_action: company.crm_next_action,
    crm_next_action_due_date: company.crm_next_action_due_date,
    crm_actions: (company.crm_actions || []).filter(action => company.campaign && action.campaign_id == company.campaign.id),
    contacts: company.contacts,
    sources: (company.sources || []).map(source => ({ id: source.id, source_name: source.source_name })),
    collection_tags: (company.collection_tags || []).filter(tag => tag.collection_tag).map(tag => ({ id: tag.collection_tag.id, collection_tag_name: tag.collection_tag.collection_tag_name })),
    saved_at: new Date().toISOString(),
  }
}

// Reads fall back to "nothing saved" if IndexedDB fails, so pages still load
export async function getSavedCompany(id) {
  try {
    return await get(Number(id), store)
  } catch (error) {
    console.log(error)
    return null
  }
}

export async function getSavedCompanies() {
  try {
    const companies = await values(store)
    return companies.sort((a, b) => a.company_name.localeCompare(b.company_name))
  } catch (error) {
    console.log(error)
    return []
  }
}

export async function saveCompany(company) {
  const savedIds = await keys(store)
  if (!savedIds.includes(company.id) && savedIds.length >= MAX_SAVED_COMPANIES) {
    return false
  }
  await set(company.id, JSON.parse(JSON.stringify(toSavedCompany(company))), store)
  return true
}

// Callers keep this within MAX_SAVED_COMPANIES
export function saveCompanies(companies) {
  return setMany(companies.map(company => [company.id, JSON.parse(JSON.stringify(toSavedCompany(company)))]), store)
}

export function unsaveCompany(id) {
  return del(Number(id), store)
}

export function unsaveCompanies(ids) {
  return delMany(ids.map(Number), store)
}

export function clearSavedCompanies() {
  return clear(store)
}
